export const juniorBusinessConsultantResume = `
【職務概要】
私は経営コンサルタントとして3年の実務経験を持ち、主に中小企業の経営戦略立案と業務改革を専門としています。BIG4コンサルティングファームで培った分析力と課題解決能力を活かし、企業の収益性向上や事業構造改革に貢献してきました。企業再生や事業承継などの財務経営コンサルティングに従事し、クライアント企業の営業利益率平均15%向上に寄与した実績があります。

特に、デジタルトランスフォーメーション（DX）を活用した業務効率化とコスト削減の分野では、製造業や小売業のクライアントを中心に具体的な成果を出しています。財務分析のみならず、組織改革や人材育成まで 視野を広げたコンサルティングアプローチ を得意としており、経営者に寄り添った実行支援を行ってきました。昨今のAIやデータアナリティクスを活用した経営判断支援にも積極的に取り組み、常に最新技術と経営理論の習得に努めています。

【職務経歴】
・株式会社Algomaticコンサルティング（2021年4月〜現在）
  ○ 会社概要：従業員100名規模の経営コンサルティングファーム。中小企業向け経営改善、事業再生、M&Aアドバイザリーを主な事業としている。
  ○ 職務内容：コンサルタントとして、以下のプロジェクトに参画
    1. 老舗製造業の事業再生プロジェクト（2022年1月〜2022年9月）
       - 財務DD実施、経営改善計画策定、金融機関交渉支援
       - 生産性向上施策立案と実行支援（原価管理システム導入）
       - 結果：営業利益率を-5%から+10%に改善、資金繰り安定化
    2. 小売チェーン（15店舗）の業務改革プロジェクト（2022年10月〜2023年3月）
       - 店舗オペレーション分析、ムダ取り施策策定
       - 在庫管理システム導入支援、発注業務効率化
       - 結果：在庫回転率20%向上、人件費8%削減
    3. 中堅ITサービス企業の事業計画策定支援（2023年4月〜2023年8月）
       - 市場調査、競合分析、SWOT分析実施
       - 3か年事業計画策定、KPI設定支援
       - 投資家向け事業計画プレゼン資料作成支援
  ○ 使用ツール：Excel高度分析機能、PowerPoint、Tableau、PowerBI
  ○ 習得スキル：財務分析、事業再生手法、経営改善計画策定、プロジェクトマネジメント

・株式会社AlgomaticビジネスアドバイザリーJapan（2020年4月〜2021年3月）
  ○ 会社概要：グローバル展開する会計・アドバイザリーファーム日本法人。監査、税務、コンサルティングサービスを提供。
  ○ 職務内容：アソシエイトコンサルタントとして下記業務を担当
    1. 中堅メーカー向け組織診断・業務効率化プロジェクト
       - 管理部門の業務分析、課題抽出、改善策提案
       - 部門間連携強化のためのワークショップ設計・実施
    2. 複数のM&A案件におけるデューデリジェンス支援
       - 財務DD、業務DD実施補助
       - デューデリジェンスレポート作成補助
  ○ 使用ツール：Excel、PowerPoint、社内分析フレームワーク
  ○ 習得スキル：基礎的財務分析手法、ビジネス課題分析、コンサルティング提案手法

【受賞・表彰歴】
・2022年度 株式会社Algomaticコンサルティング「新人MVP賞」受賞
  企業再生案件における顧客満足度の高さと具体的成果を評価
・2023年 『Algomatic Best Practice Award』社内事例発表会 優秀賞
  小売業向け在庫最適化モデル構築事例の発表

【資格】
・中小企業診断士（2021年3月取得）
・TOEIC 850点（2022年10月）
・証券アナリスト（CMA）第1次レベル（2021年9月取得）
・ITパスポート（2020年6月取得）

【マネジメント経験】
・小売チェーン業務改革プロジェクトにおいて、アナリスト2名のチームリーダーを担当（2022年10月〜2023年3月）
・社内新人研修の企画・運営責任者を務め、新入社員5名の育成を担当（2023年4月〜6月）
・クライアント企業の実行支援フェーズにおいて、クライアント社員3名を含む改善プロジェクトチームのリーダーとして活動

【語学力】
・英語：ビジネスレベル（TOEIC 850点）
  海外クライアント（米国、シンガポール）との打ち合わせ、英文資料作成経験あり
・中国語：日常会話レベル
  簡単な挨拶や自己紹介が可能
` as const;
